/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordChangeDTO
 */
export interface PasswordChangeDTO {
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeDTO
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeDTO
     */
    newPassword: string;
}

/**
 * Check if a given object implements the PasswordChangeDTO interface.
 */
export function instanceOfPasswordChangeDTO(value: object): value is PasswordChangeDTO {
    if (!('currentPassword' in value) || value['currentPassword'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    return true;
}

export function PasswordChangeDTOFromJSON(json: any): PasswordChangeDTO {
    return PasswordChangeDTOFromJSONTyped(json, false);
}

export function PasswordChangeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordChangeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPassword': json['currentPassword'],
        'newPassword': json['newPassword'],
    };
}

export function PasswordChangeDTOToJSON(value?: PasswordChangeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currentPassword': value['currentPassword'],
        'newPassword': value['newPassword'],
    };
}

